import React from "react";
import { useField } from "react-form";

export default function Select(props) {
    const {
      meta: { error, isTouched, isValidating },
      getInputProps
    } = useField(props.field, {})

    const options = (props.options || []).map((kv) => <option value={kv.value} key={kv.value}>{kv.label}</option>)

    const inputProps = getInputProps()
    inputProps.value = inputProps.value || '' // bugfix, value can't be undefined
    
    return (
      <>
        <select {...inputProps} className={props.className}>
          {options}
        </select>
      </>
    );
  }
